import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

// ✅ Ambil semua kelas online (dengan pagination & filter)
export const fetchKelasOnline = async (params = {}) => {
  try {
    const defaultParams = {
      page: 1,
      per_page: 10,
      disable_pagination: false,
      ...params
    };

    const queryParams = new URLSearchParams();
    Object.entries(defaultParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });

    const response = await axios.get(`${BASE_URL_BE}/kelas-online?${queryParams.toString()}`, {
      headers: getAuthHeaders()
    });

    return {
      success: true,
      data: response.data.data,
      meta: response.data.meta || {}
    };
  } catch (error) {
    console.error("Error fetching kelas online:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Gagal memuat data kelas online",
      error: error.response?.data || error.message
    };
  }
};

// ✅ Ambil list kelas online tanpa pagination
export const listKelasOnline = async () => {
  try {
    const params = new URLSearchParams();
    params.append('disable_pagination', 'true');

    const response = await axios.get(`${BASE_URL_BE}/kelas-online?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching list kelas online:", error);
    throw error;
  }
};

// ✅ Tambah kelas online baru
export const createKelasOnline = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/kelas-online`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating kelas online:", error);
    throw error;
  }
};

// ✅ Update kelas online
export const updateKelasOnline = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/kelas-online/${id}`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating kelas online:", error);
    throw error;
  }
};

// ✅ Hapus kelas online
export const deleteKelasOnline = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/kelas-online/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting kelas online:", error);
    throw error;
  }
};

// ✅ Ambil detail kelas online by ID
export const getKelasOnlineById = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/kelas-online/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching detail kelas online:", error);
    throw error;
  }
};


export const fetchKelasOnlineUser = async (params = {}) => {
  try {
    const defaultParams = {
      page: 1,
      per_page: 10,
      disable_pagination: false,
      ...params
    };

    const queryParams = new URLSearchParams();
    Object.entries(defaultParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });

    const response = await axios.get(`${BASE_URL_BE}/kelas-online/user?${queryParams.toString()}`, {
      headers: getAuthHeaders()
    });

    return {
      success: true,
      data: response.data.data,
      meta: response.data.meta || {}
    };
  } catch (error) {
    console.error("Error fetching kelas online:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Gagal memuat data kelas online",
      error: error.response?.data || error.message
    };
  }
};